import React from 'react'
import { connect } from 'react-redux'
import {
  setActiveTab,
  setDashboardIntervalDates,
  setUsersTableFilter,
  setIdeaTableFilter,
  setPrivateIdeaTableFilter,
} from 'actions/sync/dashboard'
import {
  getActivityTable,
  getSystemAccesses,
  getIdeasSeries,
  getIdeasTable,
  requestDashboardReport,
  getPeopleTable,
  getUsers,
  getUsersParticipation,
  getPrivateIdeasTable,
  getPrivateIdeasSeries,
  sendUsersReport,
  requestGetChallengeWithStatusFilter,
} from 'services/dashboard'
import { FIRST_LIMIT_CONSTANT } from 'common_constants/Ideas'
import { getPrivateIdeas, getIdeas } from 'services/ideas'
import { getActiveChallenges } from 'services/challenges'
import { getActiveTypes } from 'services/types'
import { getGroups } from 'services/challenge_steps'
import { getActiveOrganizations } from 'services/organizations'
import { getActiveGoals } from 'services/goals'
import {
  showPopupDialog,
  showPopupSuccessSnackbar,
  showPopupErrorSnackbar,
} from 'support/popup_dialogs'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import ModalContainer from './components/dialogs/ModalContainer'
import View from './View'

const mapStateToProps = state => ({
  challenges: state.data.challenge.challenges,
  types: state.data.domain.types,
  getChallengeWithStatusFilterListIsLoading: state.data.dashboard.getChallengeWithStatusFilterListIsLoading,
  getChallengeWithStatusFilterList: state.data.dashboard.getChallengeWithStatusFilterList,
  activeTab: state.data.dashboard.activeTab,
  activityFromDate: state.data.dashboard.activityFromDate,
  activityToDate: state.data.dashboard.activityToDate,
  ideasFromDate: state.data.dashboard.ideasFromDate,
  ideasToDate: state.data.dashboard.ideasToDate,
  peopleFromDate: state.data.dashboard.peopleFromDate,
  peopleToDate: state.data.dashboard.peopleToDate,
  privateIdeasFromDate: state.data.dashboard.privateIdeasFromDate,
  privateIdeasToDate: state.data.dashboard.privateIdeasToDate,
  activity: {
    ...state.data.dashboard.activity,
    devicesInfo: {
      ...state.data.domain.domain,
    },
  },
  ideas: state.data.dashboard.ideas,
  people: state.data.dashboard.people,
  ideaTablePagination: state.data.dashboard.ideas.pagination,
  privateIdeas: state.data.dashboard.privateIdeas,
  ideasTableBottom: state.data.dashboard.ideas.tableDataBottom.data,
  ideasTableBottomTotal: state.data.dashboard.ideas.tableDataBottom.total,
  ideasTableBottomIsLoading: state.data.dashboard.ideas.tableDataBottom.ideasLoading,
  isLoading: state.data.dashboard.isLoading,
  isActivitySeriesLoading: state.data.dashboard.isActivitySeriesLoading,
  isIdeasSeriesLoading: state.data.dashboard.isIdeasSeriesLoading,
  isUsersParticipationSeriesLoading: state.data.dashboard.isUsersParticipationSeriesLoading,
  users: state.data.dashboard.people.usersTable.users,
  peopleUserFilter: state.data.dashboard.people.usersTable.filter,
  isUserTableLoading: state.data.dashboard.people.usersTable.isLoading,
  isPrivateIdeasLoading: state.data.dashboard.isPrivateIdeasSeriesLoading,
  showPrivateTab: state.data.domain.domainConfiguration.isPrivateFlowActive,
  userTableFilter: state.data.dashboard.people.usersTable.filter,
  domainCreationDate: state.data.domain.domain.domainCreationDate,
  usersParticipation: state.data.dashboard.people.usersParticipation,
  organizations: state.data.domain.organizations,
  groups: state.data.challengeSteps.preview.defaultGroups,
  strategics: state.data.domain.goals,
  isHackathonEnable:state.data.domain.config.globalIsHackthon,
  userEmail: state.data.user.userEmail,
  csrfToken: state.auth.csrf,
 
})
const mapDispatchToProps = dispatch => ({
  onChangeTab: activeTab => {
    dispatch(setActiveTab(activeTab))
  },
  onChangeDate: (activeTab, date) => {
    dispatch(setDashboardIntervalDates(activeTab, date))
  },
  getActivityComparisonTable: (fromDate, toDate) => dispatch(getActivityTable(fromDate, toDate)),
  getIdeasComparisonTable: (fromDate, toDate) => dispatch(getIdeasTable(fromDate, toDate)),
  getPeopleComparisonTable: (fromDate, toDate) => dispatch(getPeopleTable(fromDate, toDate)),
  getPrivateIdeasComparisonTable: (fromDate, toDate) =>
    dispatch(getPrivateIdeasTable(fromDate, toDate)),
  getSystemAccesses: fromDate => dispatch(getSystemAccesses(fromDate)),
  getIdeasSeries: fromDate => dispatch(getIdeasSeries(fromDate)),
  getUsers: filter => dispatch(getUsers(filter)),
  setUsersTableFilter: filter => dispatch(setUsersTableFilter(filter)),
  setIdeaTableFilter: filter => dispatch(setIdeaTableFilter(filter)),
  setPrivateIdeaTableFilter: filter => dispatch(setPrivateIdeaTableFilter(filter)),
  getUserParticipation: offset => dispatch(getUsersParticipation(offset)),
  getPrivateIdeasSeries: fromDate => dispatch(getPrivateIdeasSeries(fromDate)),
  onSendReport: value => {
    const onSuccess = () => {
      showPopupDialog(
        <ModalContainer
          description={i18n.t('DASHBOARD.SENDED')}
          title={i18n.t('DASHBOARD.REQUESTED')}
        />,
        dispatch,
      )
    }
    dispatch(requestDashboardReport(value, onSuccess))
  },
  navigateToUserProfile: email => dispatch(Navigation.navigateToUserProfile(email)),
  onSendPeopleReport: () => {
    const onSuccess = () => showPopupSuccessSnackbar(i18n.t('DASHBOARD.SENDED'), dispatch)
    dispatch(sendUsersReport(onSuccess))
  },
  getPrivateIdeas: ({
    challenge,
    organizations,
    status,
    types,
    limit,
    offset,
    goal,
    group,
  } = {}) => {
    const onFailure = () =>
      showPopupErrorSnackbar(i18n.t('PROFILE.ERROR_PROCESSING_REQUEST'), dispatch)
    dispatch(
      getPrivateIdeas(
        {
          challenge,
          organizations,
          status,
          types,
          limit,
          offset,
          goal,
          group,
        },
        onFailure,
      ),
    )
  },
  getIdeas: ({ challenge, organizations, status, types, limit, offset, goal, group } = {}) => {
    const onFailure = () => {
      showPopupErrorSnackbar(i18n.t('PROFILE.ERROR_PROCESSING_REQUEST'), dispatch)
    }
    dispatch(
      getIdeas({ challenge, organizations, status, types, limit, offset, goal, group }, onFailure),
    )
  },
  navigateToIdea: id => {
    dispatch(Navigation.navigateToIdea(id))
  },
  getActiveOrganizations: () => dispatch(getActiveOrganizations()),
  getGroups: () => dispatch(getGroups()),
  getActiveGoals: () => dispatch(getActiveGoals()),
  getActiveChallenges: (status = 'ACTIVE',offset=0, limitValue = FIRST_LIMIT_CONSTANT,limitGroups = false,isHackathonEnable) => dispatch(getActiveChallenges(status, offset, limitValue, limitGroups, isHackathonEnable)),

 requestGetChallengeWithStatusFilterFn: filters => {
  dispatch(
    requestGetChallengeWithStatusFilter(filters)
  );
},
  
  getActiveTypes: () => dispatch(getActiveTypes()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)